// extracted by mini-css-extract-plugin
module.exports = {"breadcrumbs":"a10a3f92e9--breadcrumbs--1kChM","link":"a10a3f92e9--link--378yo"};